export default __webpack_public_path__ + "static/media/38.413e0b09.gif";